import { Service } from 'react-service-locator';
import axiosInstance from '../axios/axiosAuthInterceptor';

export type TeamMember = {
    id: string;
    email: string;
    fullName: string;
    phoneNumber: string;
    isMaster?: boolean;
};

export type TeamResponse = {
    clientId: string | null;
    memberCount: number;
    members: TeamMember[];
};

export type SeatsResponse = {
    seats: number;
    extraSeats: number;
    members: number;
    availableSeats: number;
    maxSeats: number;
    subscriptionId: string;
};

export type AddUserApiResponse =
    | {
          message: 'UserAdded';
          paidSeats: number;
          members: number;
          availableSeats: number;
      }
    | {
          status: 'RequiresPayment';
          message: string;
          invoiceId: string;
          hostedInvoiceUrl: string;
          paidSeats: number;
          members: number;
          availableSeats: number;
      };

@Service()
export class TeamService {
    async getTeam(): Promise<TeamResponse> {
        const res = await axiosInstance.get('/Stripe/smallorg/team');
        return res.data;
    }

    async getSeats(): Promise<SeatsResponse> {
        const res = await axiosInstance.get('/Stripe/smallorg/seats');
        return res.data;
    }

    async addUser(payload: { email: string; firstName?: string; lastName?: string; phoneNumber?: string }) {
        const res = await axiosInstance.post('/Stripe/smallorg/add-user', payload);
        return res.data as AddUserApiResponse;
    }

    async removeUser(userId: string) {
        const res = await axiosInstance.post('/Stripe/smallorg/remove-user', { userId });
        return res.data;
    }
}
